(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hongteya-mobile-bottom-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const chatBottomOffset = 'calc(10.2rem + env(safe-area-inset-bottom))';
    const mobileViewport = window.matchMedia('(max-width: 749px)');
    const observedChatRoots = new WeakSet();
    const chatObservers = [];

    const findInOpenShadowRoots = (root, selector) => {
      if (!root) return null;

      const match = root.querySelector(selector);
      if (match) return match;

      for (const element of root.querySelectorAll('*')) {
        if (!element.shadowRoot) continue;
        const nestedMatch = findInOpenShadowRoots(element.shadowRoot, selector);
        if (nestedMatch) return nestedMatch;
      }

      return null;
    };

    const observeOpenShadowRoots = (root) => {
      if (!root) return;

      if (!observedChatRoots.has(root)) {
        const observer = new MutationObserver(() => positionChatLauncher());
        observer.observe(root, { childList: true, subtree: true });
        observedChatRoots.add(root);
        chatObservers.push(observer);
      }

      for (const element of root.querySelectorAll('*')) {
        if (element.shadowRoot) observeOpenShadowRoots(element.shadowRoot);
      }
    };

    const positionChatLauncher = () => {
      const chat = document.querySelector('shopify-chat');
      const root = chat?.shadowRoot;
      const launcher = findInOpenShadowRoots(root, '.activator-nudge');
      if (!root || !launcher) return false;

      if (mobileViewport.matches) {
        launcher.style.setProperty('bottom', chatBottomOffset, 'important');
        launcher.style.setProperty('right', '1.8rem', 'important');
      } else {
        launcher.style.removeProperty('bottom');
        launcher.style.removeProperty('right');
      }

      observeOpenShadowRoots(root);

      return true;
    };

    let chatAttempts = 0;
    const chatTimer = window.setInterval(() => {
      chatAttempts += 1;
      if (positionChatLauncher() || chatAttempts >= 40) window.clearInterval(chatTimer);
    }, 250);

    window.addEventListener('resize', positionChatLauncher, { passive: true });
    mobileViewport.addEventListener('change', positionChatLauncher);

    const cartCount = document.querySelector('[data-mobile-cart-count]');
    if (!cartCount) return;

    const updateCount = (value) => {
      const count = Number(value);
      if (!Number.isFinite(count)) return;
      cartCount.textContent = count > 99 ? '99+' : String(count);
      cartCount.hidden = count === 0;
    };

    const refreshCount = () => {
      if (!window.routes?.cart_url) return;
      fetch(`${window.routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cart) => updateCount(cart.item_count))
        .catch(() => {});
    };

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (Number.isFinite(Number(event?.cartData?.item_count))) {
          updateCount(event.cartData.item_count);
        } else {
          refreshCount();
        }
      });
    }
  }, { once: true });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.hongteyaProductGalleryNavigation) return;

    window.hongteyaProductGalleryNavigation = true;

    const navigationSelector = 'media-gallery [id^="GalleryThumbnails-"] > .slider-button[name]';
    const observedButtons = new WeakSet();
    const observedGalleries = new WeakSet();

    const syncThumbnailHeight = (gallery) => {
      const viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (!viewer) return;

      const updateHeight = () => {
        if (window.matchMedia('(min-width: 750px)').matches) {
          const viewerHeight = viewer.getBoundingClientRect().height;
          if (viewerHeight > 0) {
            gallery.style.setProperty('--hongteya-gallery-viewer-height', `${viewerHeight}px`);
          }
        } else {
          gallery.style.removeProperty('--hongteya-gallery-viewer-height');
        }
      };

      updateHeight();
      if (observedGalleries.has(gallery)) return;

      observedGalleries.add(gallery);
      new ResizeObserver(updateHeight).observe(viewer);
      window.addEventListener('resize', updateHeight, { passive: true });
    };

    const keepNavigationEnabled = () => {
      document.querySelectorAll(navigationSelector).forEach((button) => {
        button.removeAttribute('disabled');

        if (observedButtons.has(button)) return;

        observedButtons.add(button);
        new MutationObserver(() => button.removeAttribute('disabled')).observe(button, {
          attributes: true,
          attributeFilter: ['disabled'],
        });
      });

      document.querySelectorAll('media-gallery').forEach(syncThumbnailHeight);
    };

    keepNavigationEnabled();
    document.addEventListener('shopify:section:load', keepNavigationEnabled);

    document.addEventListener(
      'click',
      (event) => {
        const navigationButton = event.target.closest(navigationSelector);
        if (!navigationButton) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const gallery = navigationButton.closest('media-gallery');
        if (!gallery || typeof gallery.setActiveMedia !== 'function') return;

        const thumbnails = Array.from(
          gallery.querySelectorAll('[id^="Slider-Thumbnails-"] [data-target]')
        ).filter((thumbnail) => {
          const styles = window.getComputedStyle(thumbnail);
          return styles.display !== 'none' && styles.visibility !== 'hidden';
        });

        if (thumbnails.length < 2) return;

        const activeIndex = thumbnails.findIndex((thumbnail) =>
          thumbnail.querySelector('button[aria-current="true"]')
        );
        const currentIndex = activeIndex >= 0 ? activeIndex : 0;
        const direction = navigationButton.name === 'next' ? 1 : -1;
        const nextIndex = (currentIndex + direction + thumbnails.length) % thumbnails.length;
        const nextThumbnail = thumbnails[nextIndex];

        gallery.setActiveMedia(nextThumbnail.dataset.target, false);
        nextThumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      },
      true
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
